var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"267c764b41093e7a1c591d4e84aa006961b62992"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["archivizer-com@archivizer"]={id:"267c764b41093e7a1c591d4e84aa006961b62992"};
      